import React from 'react'
import {ArtifactAttribute} from '../attributeTemplates/ArtifactAttribute'
import {sortAttributesByDisplayOrder} from '../utils/sortedDefinitions'
import {AttributeDefinitionModel} from '../model/AttributeModel'

export const RegulationProofsDefinition = ({definition}: {definition: AttributeDefinitionModel}) => {
    return (
        <div
            className="display-set-definition display-set-attribute-regulation"
            data-testid="test-details-regulation-proofs-definition"
            id={definition.attributeDefinitionId}
        >
            <>
                {sortAttributesByDisplayOrder(definition.attributes).map((attribute) =>
                    attribute.value.composedByAttributes.map((composedAttribute) =>
                        <>
                            <span className="definition-name">{composedAttribute.name}</span>
                            <ArtifactAttribute key={composedAttribute.id} attribute={composedAttribute} />
                        </>
                    )
                )}
            </>
        </div>
    )
}
